import ESuranceMembershipModelBase from '../_generated/modelBases/e-surance-membership-model-base';

export default class ESuranceMembershipModel extends ESuranceMembershipModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
